module.exports = __webpack_public_path__ + "img/tj.9ddd6cb9.png";